'use client'

import { createContext, ReactNode, useContext } from 'react'

import type { SettingsQueryResult } from '@/sanity.types'

type SettingsContextType = SettingsQueryResult | null

const SettingsContext = createContext<SettingsContextType>(null)

export function SettingsProvider({
  settings,
  children,
}: {
  settings: SettingsQueryResult
  children: ReactNode
}) {
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>
}

export function useSettings() {
  const context = useContext(SettingsContext)
  if (context === undefined) {
    throw new Error('useSettings must be used within a SettingsProvider')
  }
  return context
}
